// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGContrastIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGContrastIcon extends PureComponent<
  ISVGContrastIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill={fill || "currentColor"}
        style={style}
        width="45px"
        height="45px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 45 45"
      >
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          d="M18.316,2.18
		C9.371,2.18,2.12,9.431,2.12,18.376s7.251,16.197,16.197,16.197c8.944,0,16.196-7.251,16.196-16.197
		C34.512,9.431,27.261,2.18,18.316,2.18z M18.316,32.664c-7.891,0-14.288-6.397-14.288-14.289c0-7.89,6.396-14.287,14.288-14.287
		c7.891,0,14.288,6.396,14.288,14.287C32.604,26.267,26.207,32.664,18.316,32.664z"
        />
        <path
          fill="#8694B1"
          stroke="#8694B1"
          strokeMiterlimit="10"
          d="M17.5,6.262c0,7.901,0,15.803,0,23.703
		c-6.262,0.074-9.688-3.632-11.353-8.194c-0.595-1.632-0.944-4.882-0.294-6.875C7.391,10.179,11.165,6.194,17.5,6.262z"
        />
        <path
          fill="#1B2332"
          stroke="#8694B1"
          strokeWidth="0.5"
          strokeMiterlimit="10"
          d="M16.804,0.797
		c-8.946,0-16.197,7.251-16.197,16.196c0,8.946,7.251,16.198,16.197,16.198c8.944,0,16.196-7.25,16.196-16.198
		C32.999,8.048,25.748,0.797,16.804,0.797z M16.804,31.283c-7.891,0-14.288-6.398-14.288-14.291c0-7.89,6.396-14.287,14.288-14.287
		c7.891,0,14.288,6.396,14.288,14.287C31.092,24.885,24.694,31.283,16.804,31.283z"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="32.256"
          y1="12.13"
          x2="33.724"
          y2="13.377"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="32.256"
          y1="21.51"
          x2="33.97"
          y2="22.545"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="26.674"
          y1="29.965"
          x2="28.444"
          y2="31.013"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="18.316"
          y1="33.191"
          x2="19.48"
          y2="34.528"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="8.69"
          y1="31.013"
          x2="8.907"
          y2="31.556"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="3.746"
          y1="11.185"
          x2="4.474"
          y2="12.13"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="2.828"
          y1="19.971"
          x2="4.177"
          y2="20.43"
        />
        <line
          fill="none"
          stroke="#8694B1"
          strokeMiterlimit="10"
          x1="15.956"
          y1="2.731"
          x2="16.747"
          y2="3.858"
        />
      </svg>
    );
  }
}
